// KBPE-46: sessionStorage marker for a checkout entered via the post-signup paid-intent redirect.
// Kept outside the store on purpose: components importing it must not import '@/store/subscription'
// directly, as that module imports '@/store' and loading it first breaks the store setup (import cycle).
const PAID_INTENT_SIGNUP_STORAGE_KEY = 'qrcg_paid_intent_signup';

export function hasPaidIntentSignupMarker(): boolean {
  try {
    return sessionStorage.getItem(PAID_INTENT_SIGNUP_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setPaidIntentSignupMarker(isPaidIntentSignup: boolean): void {
  try {
    if (isPaidIntentSignup) {
      sessionStorage.setItem(PAID_INTENT_SIGNUP_STORAGE_KEY, '1');
    } else {
      sessionStorage.removeItem(PAID_INTENT_SIGNUP_STORAGE_KEY);
    }
  } catch {
    // sessionStorage can be unavailable (e.g. blocked storage); the in-memory flag still works
  }
}
